export default ">> **You will require at least User Level access for successful integration.**";